export interface ConnectorFlashcard {
  id: string;
  category: string;
  front: string;
  back: string;
  example: string;
  tags: string[];
}

export const frenchConnectorFlashcards: ConnectorFlashcard[] = [
  // --- ORGANISATION ---
  {
    id: "connector-tout-dabord",
    category: "Organisation",
    front: "Que signifie « Tout d'abord » ?",
    back: "Primeiramente / Antes de tudo",
    example: "Tout d'abord, il est important de comprendre le contexte économique.",
    tags: ["connecteur", "organisation", "écriture"]
  },
  {
    id: "connector-premierement",
    category: "Organisation",
    front: "Que signifie « Premièrement » ?",
    back: "Em primeiro lugar",
    example: "Premièrement, analysons les causes directes de ce phénomène.",
    tags: ["connecteur", "organisation", "écriture"]
  },
  {
    id: "connector-deuxiemement",
    category: "Organisation",
    front: "Que signifie « Deuxièmement » ?",
    back: "Em segundo lugar",
    example: "Deuxièmement, il faut prendre en compte les conséquences sociales.",
    tags: ["connecteur", "organisation", "écriture"]
  },
  {
    id: "connector-ensuite",
    category: "Organisation",
    front: "Que signifie « Ensuite » ?",
    back: "Em seguida / Depois",
    example: "Nous aborderons ensuite les solutions envisageables.",
    tags: ["connecteur", "organisation", "écriture"]
  },
  {
    id: "connector-puis",
    category: "Organisation",
    front: "Que signifie « Puis » ?",
    back: "Depois / Então",
    example: "Il a présenté son projet, puis il a réponded aux questions.",
    tags: ["connecteur", "organisation", "écriture"]
  },
  {
    id: "connector-enfin",
    category: "Organisation",
    front: "Que signifie « Enfin » ?",
    back: "Por fim / Finalmente",
    example: "Enfin, rappelons que chaque citoyen a un rôle à jouer.",
    tags: ["connecteur", "organisation", "écriture"]
  },
  {
    id: "connector-dune-part",
    category: "Organisation",
    front: "Que signifie « D'une part » ?",
    back: "Por un lado",
    example: "D'une part, les technologies facilitent la communication.",
    tags: ["connecteur", "organisation", "écriture"]
  },
  {
    id: "connector-dautre-part",
    category: "Organisation",
    front: "Que signifie « D'autre part » ?",
    back: "Por outro lado",
    example: "D'autre part, elles peuvent créer une certaine dépendance.",
    tags: ["connecteur", "organisation", "écriture"]
  },

  // --- ADDITION ---
  {
    id: "connector-de-plus",
    category: "Addition",
    front: "Que signifie « De plus » ?",
    back: "Além disso / Ademais",
    example: "De plus, ce programme offre des bourses d'études intéressantes.",
    tags: ["connecteur", "addition", "écriture"]
  },
  {
    id: "connector-en-outre",
    category: "Addition",
    front: "Que signifie « En outre » ?",
    back: "Além do mais / Outrossim",
    example: "En outre, la nouvelle loi prévoit des sanctions plus sévères.",
    tags: ["connecteur", "addition", "écriture"]
  },
  {
    id: "connector-par-ailleurs",
    category: "Addition",
    front: "Que signifie « Par ailleurs » ?",
    back: "Por outro lado / Além disso",
    example: "Par ailleurs, il convient de souligner l'effort des bénévoles.",
    tags: ["connecteur", "addition", "écriture"]
  },
  {
    id: "connector-egalement",
    category: "Addition",
    front: "Que signifie « Également » ?",
    back: "Igualmente / Também",
    example: "Cette mesure concerne également les entreprises privées.",
    tags: ["connecteur", "addition", "écriture"]
  },
  {
    id: "connector-aussi",
    category: "Addition",
    front: "Que signifie « Aussi » ?",
    back: "Também",
    example: "Il participe aussi au développement de la communauté locale.",
    tags: ["connecteur", "addition", "écriture"]
  },
  {
    id: "connector-non-seulement",
    category: "Addition",
    front: "Que signifie « Non seulement... mais aussi » ?",
    back: "Não apenas... mas também",
    example: "Non seulement il a étudié, mais il a aussi fait un stage.",
    tags: ["connecteur", "addition", "écriture"]
  },

  // --- OPPOSITION / CONCESSION ---
  {
    id: "connector-mais",
    category: "Opposition / Concession",
    front: "Que signifie « Mais » ?",
    back: "Mas / Porém",
    example: "Le projet est ambitieux, mais il nécessite des fonds.",
    tags: ["connecteur", "opposition", "concession"]
  },
  {
    id: "connector-cependant",
    category: "Opposition / Concession",
    front: "Que signifie « Cependant » ?",
    back: "No entanto / Entretanto / Porém",
    example: "Il a beaucoup étudié ; cependant, il reste nerveux.",
    tags: ["connecteur", "opposition", "concession"]
  },
  {
    id: "connector-pourtant",
    category: "Opposition / Concession",
    front: "Que signifie « Pourtant » ?",
    back: "No entanto / Contudo (frequentemente expressa surpresa ou indignação)",
    example: "Il pleut, et pourtant il sort sans parapluie.",
    tags: ["connecteur", "opposition", "concession"]
  },
  {
    id: "connector-toutefois",
    category: "Opposition / Concession",
    front: "Que signifie « Toutefois » ?",
    back: "Todavia / Contudo",
    example: "Toutefois, quelques exceptions confirment la règle.",
    tags: ["connecteur", "opposition", "concession"]
  },
  {
    id: "connector-neanmoins",
    category: "Opposition / Concession",
    front: "Que signifie « Néanmoins » ?",
    back: "Apesar disso / Não obstante",
    example: "La situation est complexe ; néanmoins, un accord a été trouvé.",
    tags: ["connecteur", "opposition", "concession"]
  },
  {
    id: "connector-en-revanche",
    category: "Opposition / Concession",
    front: "Que signifie « En revanche » ?",
    back: "Em compensação / Por outro lado",
    example: "L'hiver est rude ; en revanche, l'été est très agréable.",
    tags: ["connecteur", "opposition", "concession"]
  },
  {
    id: "connector-au-contraire",
    category: "Opposition / Concession",
    front: "Que signifie « Au contraire » ?",
    back: "Pelo contrário",
    example: "Il n'est pas fatigué ; au contraire, il déborde d'énergie.",
    tags: ["connecteur", "opposition", "concession"]
  },
  {
    id: "connector-bien-que",
    category: "Opposition / Concession",
    front: "Que signifie « Bien que » ? (Suivi de quel mode ?)",
    back: "Embora / Ainda que (seguido de Subjuntivo)",
    example: "Bien qu'il soit tard, nous continuons à travailler.",
    tags: ["connecteur", "opposition", "concession"]
  },
  {
    id: "connector-meme-si",
    category: "Opposition / Concession",
    front: "Que signifie « Même si » ? (Suivi de quel mode ?)",
    back: "Mesmo se / Mesmo que (seguido de Indicativo)",
    example: "Même s'il fait froid, je vais faire un tour au parc.",
    tags: ["connecteur", "opposition", "concession"]
  },
  {
    id: "connector-malgre",
    category: "Opposition / Concession",
    front: "Que signifie « Malgré » ? (Suivi de quoi ?)",
    back: "Apesar de (seguido de substantivo)",
    example: "Malgré la pluie, le festival a attiré une foule nombreuse.",
    tags: ["connecteur", "opposition", "concession"]
  },
  {
    id: "connector-malgre-le-fait-que",
    category: "Opposition / Concession",
    front: "Que signifie « Malgré le fait que » ?",
    back: "Apesar do fato de que",
    example: "Malgré le fait qu'il ait peu d'expérience, il a obtenu le poste.",
    tags: ["connecteur", "opposition", "concession"]
  },

  // --- CAUSE ---
  {
    id: "connector-parce-que",
    category: "Cause",
    front: "Que signifie « Parce que » ?",
    back: "Porque (responde à pergunta 'pourquoi' e introduz a causa neutra)",
    example: "Il apprend le français parce qu'il veut vivre au Québec.",
    tags: ["connecteur", "cause"]
  },
  {
    id: "connector-car",
    category: "Cause",
    front: "Que signifie « Car » ?",
    back: "Pois / Porque (introduz uma explicação ou justificativa)",
    example: "Je dois partir, car mon train arrive dans dix minutes.",
    tags: ["connecteur", "cause"]
  },
  {
    id: "connector-puisque",
    category: "Cause",
    front: "Que signifie « Puisque » ?",
    back: "Já que / Visto que (introduz uma causa já conhecida pelo interlocutor)",
    example: "Puisque tout le monde est d'accord, signons le contrat.",
    tags: ["connecteur", "cause"]
  },
  {
    id: "connector-grace-a",
    category: "Cause",
    front: "Que signifie « Grâce à » ?",
    back: "Graças a (introduz uma causa positiva)",
    example: "Grâce à ses efforts, elle a réussi le TEF avec brio.",
    tags: ["connecteur", "cause"]
  },
  {
    id: "connector-a-cause-de",
    category: "Cause",
    front: "Que signifie « À cause de » ?",
    back: "Por causa de / Devido a (introduz uma causa negativa ou neutra)",
    example: "Le vol a été retardé à cause de la tempête de neige.",
    tags: ["connecteur", "cause"]
  },
  {
    id: "connector-en-raison-de",
    category: "Cause",
    front: "Que signifie « En raison de » ?",
    back: "Em razão de / Em virtude de (termo formal)",
    example: "En raison des travaux, la rue sera fermée demain.",
    tags: ["connecteur", "cause"]
  },
  {
    id: "connector-etant-donne-que",
    category: "Cause",
    front: "Que signifie « Étant donné que » ?",
    back: "Tendo em vista que / Dado que",
    example: "Étant donné que le marché évolue, nous devons nous adapter.",
    tags: ["connecteur", "cause"]
  },

  // --- CONSÉQUENCE ---
  {
    id: "connector-donc",
    category: "Conséquence",
    front: "Que signifie « Donc » ?",
    back: "Portanto / Logo / Então",
    example: "Je pense, donc je suis. (Descartes)",
    tags: ["connecteur", "consequence"]
  },
  {
    id: "connector-alors",
    category: "Conséquence",
    front: "Que signifie « Alors » ?",
    back: "Então / Assim",
    example: "Il n'y avait plus de bus, alors nous avons pris un taxi.",
    tags: ["connecteur", "consequence"]
  },
  {
    id: "connector-ainsi",
    category: "Conséquence",
    front: "Que signifie « Ainsi » ?",
    back: "Assim / Desse modo",
    example: "Ainsi, l'entreprise a pu réduire ses coûts de fonctionnement.",
    tags: ["connecteur", "consequence"]
  },
  {
    id: "connector-par-consequent",
    category: "Conséquence",
    front: "Que signifie « Par conséquent » ?",
    back: "Por conseguinte / Consequentemente",
    example: "Le budget est limité ; par conséquent, certains projets seront reportés.",
    tags: ["connecteur", "consequence"]
  },
  {
    id: "connector-cest-pourquoi",
    category: "Conséquence",
    front: "Que signifie « C'est pourquoi » ?",
    back: "É por isso que",
    example: "Le climat est propice ; c'est pourquoi la région attire beaucoup de touristes.",
    tags: ["connecteur", "consequence"]
  },
  {
    id: "connector-de-sorte-que",
    category: "Conséquence",
    front: "Que signifie « De sorte que » ?",
    back: "De modo que / De sorte que",
    example: "Il a bien expliqué les règles, de sorte que tout le monde a compris.",
    tags: ["connecteur", "consequence"]
  },
  {
    id: "connector-si-bien-que",
    category: "Conséquence",
    front: "Que signifie « Si bien que » ?",
    back: "De tal modo que / Tanto que",
    example: "Il a plu toute la nuit, si bien que les routes sont inondées.",
    tags: ["connecteur", "consequence"]
  },

  // --- BUT ---
  {
    id: "connector-pour",
    category: "But",
    front: "Que signifie « Pour » ? (Suivi de quoi ?)",
    back: "Para (seguido de verbo no infinitivo ou substantivo)",
    example: "Il étudie chaque jour pour améliorer son score.",
    tags: ["connecteur", "but"]
  },
  {
    id: "connector-afin-de",
    category: "But",
    front: "Que signifie « Afin de » ? (Suivi de quoi ?)",
    back: "A fim de (seguido de verbo no infinitivo)",
    example: "Afin de garantir votre place, veuillez confirmer votre inscription.",
    tags: ["connecteur", "but"]
  },
  {
    id: "connector-afin-que",
    category: "But",
    front: "Que signifie « Afin que » ? (Suivi de quel mode ?)",
    back: "A fim de que / Para que (seguido de Subjuntivo)",
    example: "Je vous envoie ce courriel afin que vous soyez informé.",
    tags: ["connecteur", "but"]
  },
  {
    id: "connector-dans-le-but-de",
    category: "But",
    front: "Que signifie « Dans le but de » ?",
    back: "Com o objetivo de / No intuito de",
    example: "Ce séminaire est organisé dans le but de former les nouveaux employés.",
    tags: ["connecteur", "but"]
  },

  // --- EXEMPLE ---
  {
    id: "connector-par-exemple",
    category: "Exemple",
    front: "Que signifie « Par exemple » ?",
    back: "Por exemplo",
    example: "Certains secteurs recrutent massivement, par exemple la santé et l'informatique.",
    tags: ["connecteur", "exemple"]
  },
  {
    id: "connector-notamment",
    category: "Exemple",
    front: "Que signifie « Notamment » ?",
    back: "Notadamente / Especialmente / Em particular",
    example: "Il s'intéresse à la littérature francophone, notamment aux auteurs québécois.",
    tags: ["connecteur", "exemple"]
  },
  {
    id: "connector-en-particulier",
    category: "Exemple",
    front: "Que signifie « En particulier » ?",
    back: "Em particular / Particularmente",
    example: "Cette offre s'adresse aux jeunes diplômémés en particulier.",
    tags: ["connecteur", "exemple"]
  },
  {
    id: "connector-comme-exemple",
    category: "Exemple",
    front: "Que signifie « Comme » ? (Pour introduire des exemples)",
    back: "Como / Tais como",
    example: "Des activités culturelles, comme le théâtre et le cinéma, sont proposées.",
    tags: ["connecteur", "exemple"]
  },

  // --- CONCLUSION ---
  {
    id: "connector-en-conclusion",
    category: "Conclusion",
    front: "Que signifie « En conclusion » ?",
    back: "Em conclusão",
    example: "En conclusion, l'immigration apporte une richesse culturelle indéniable.",
    tags: ["connecteur", "conclusion", "écriture"]
  },
  {
    id: "connector-pour-conclure",
    category: "Conclusion",
    front: "Que signifie « Pour conclure » ?",
    back: "Para concluir",
    example: "Pour conclure, il est urgent de prendre des mesures écologiques.",
    tags: ["connecteur", "conclusion", "écriture"]
  },
  {
    id: "connector-en-somme",
    category: "Conclusion",
    front: "Que signifie « En somme » ?",
    back: "Em suma / Em resumo",
    example: "En somme, les bénéfices dépassent largement les coûts.",
    tags: ["connecteur", "conclusion", "écriture"]
  },
  {
    id: "connector-finalement",
    category: "Conclusion",
    front: "Que signifie « Finalement » ?",
    back: "Finalmente / No final das contas",
    example: "Finalement, le compromis adopté satisfait les deux parties.",
    tags: ["connecteur", "conclusion", "écriture"]
  },
  {
    id: "connector-bref",
    category: "Conclusion",
    front: "Que signifie « Bref » ?",
    back: "Em resumo / Trocando em miúdos (informal/direto)",
    example: "Bref, ce fut une expérience inoubliable.",
    tags: ["connecteur", "conclusion", "écriture"]
  },

  // --- OPINION / ARGUMENTATION ---
  {
    id: "connector-selon-moi",
    category: "Opinion / Argumentation",
    front: "Que signifie « Selon moi » ?",
    back: "Segundo mim / De acordo comigo",
    example: "Selon moi, la formation continue est la clé du succès professionnel.",
    tags: ["connecteur", "opinion", "argumentation"]
  },
  {
    id: "connector-a-mon-avis",
    category: "Opinion / Argumentation",
    front: "Que signifie « À mon avis » ?",
    back: "Na minha opinião / A meu ver",
    example: "À mon avis, cette réforme apportera plus de flexibilité.",
    tags: ["connecteur", "opinion", "argumentation"]
  },
  {
    id: "connector-il-me-semble-que",
    category: "Opinion / Argumentation",
    front: "Que signifie « Il me semble que » ?",
    back: "Parece-me que",
    example: "Il me semble que la communication est la base de toute relation.",
    tags: ["connecteur", "opinion", "argumentation"]
  },
  {
    id: "connector-je-pense-que",
    category: "Opinion / Argumentation",
    front: "Que signifie « Je pense que » ?",
    back: "Eu penso que / Eu acho que",
    example: "Je pense que nous devrions investir davantage dans les énergies propres.",
    tags: ["connecteur", "opinion", "argumentation"]
  },
  {
    id: "connector-je-suis-convaincu-que",
    category: "Opinion / Argumentation",
    front: "Que signifie « Je suis convaincu(e) que » ?",
    back: "Estou convencido(a) de que",
    example: "Je suis convaincu que le télétravail va s'installer durablement.",
    tags: ["connecteur", "opinion", "argumentation"]
  },
  {
    id: "connector-il-est-essentiel-de",
    category: "Opinion / Argumentation",
    front: "Que signifie « Il est essentiel de » ?",
    back: "É essencial / É fundamental (seguido de infinitivo)",
    example: "Il est essentiel de maintenir un équilibre entre vie privée et professionnelle.",
    tags: ["connecteur", "opinion", "argumentation"]
  },
  {
    id: "connector-il-faut-reconnaitre-que",
    category: "Opinion / Argumentation",
    front: "Que signifie « Il faut reconnaître que » ?",
    back: "É preciso reconhecer que / Há que se admitir que",
    example: "Il faut reconnaître que les efforts gouvernementaux ont porté leurs fruits.",
    tags: ["connecteur", "opinion", "argumentation"]
  },

  // --- COMPARAISON ---
  {
    id: "connector-comme-comparaison",
    category: "Comparaison",
    front: "Que signifie « Comme » ? (Pour exprimer une comparaison ou similarité)",
    back: "Como / Tal qual",
    example: "Il réagit exactement comme son frère dans cette situation.",
    tags: ["connecteur", "comparaison"]
  },
  {
    id: "connector-de-meme-que",
    category: "Comparaison",
    front: "Que signifie « De même que » ?",
    back: "Assim como / Da mesma forma que",
    example: "De même que l'eau est vitale pour le corps, l'éducation est vitale pour l'esprit.",
    tags: ["connecteur", "comparaison"]
  },
  {
    id: "connector-contrairement-a",
    category: "Comparaison",
    front: "Que signifie « Contrairement à » ?",
    back: "Ao contrário de / Diferentemente de",
    example: "Contrairement aux idées reçues, ce secteur recrute beaucoup.",
    tags: ["connecteur", "comparaison"]
  },
  {
    id: "connector-tandis-que",
    category: "Comparaison",
    front: "Que signifie « Tandis que » ?",
    back: "Enquanto que / Ao passo que",
    example: "Le Québec est majoritairement francophone, tandis que l'Ontario est anglophone.",
    tags: ["connecteur", "comparaison"]
  },
  {
    id: "connector-alors-que",
    category: "Comparaison",
    front: "Que signifie « Alors que » ?",
    back: "Enquanto que / Ao passo que (marca contraste ou simultaneidade)",
    example: "Elle préfère la ville, alors que son mari préfère la campagne.",
    tags: ["connecteur", "comparaison"]
  }
];
